import React from 'react';
import { connect } from 'react-redux';
import {Row,Col,Modal} from 'react-bootstrap';
import { userService } from '../../_services';
import { Formik, Form,  Field } from 'formik';
import {CampoPassword, ERR, ErrorMessage, LoadingBoton} from '../../_helpers';
import * as Yup from 'yup';
import alertService from '../../_services/cart/alert.service';

class FormCambiarPassword extends React.Component { 
 
     state = {
         grabando:false,
         mostrar:false
     };
 
     componentDidMount(){
      
     }

     render(){
          const passwoordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
          const {mostrar} = this.state;
          let inic={
            password:'',
            confpassword:''
          }

         const validationSchema = Yup.object().shape({
              password: Yup.string().required(ERR.REQ).min(8, 'El password debe contener al menos 8 caracteres').matches(passwoordRegExp,'Al menos 8 caracteres, una letra y un número!').max(50, 'Demasiado largo'),
              confpassword: Yup.string().required(ERR.REQ).oneOf([Yup.ref('password'), null], "Las contraseñas no coinciden")
          });
   
         return(
         
          <Modal show={this.props.show} onHide={()=>this.props.handleClose()} backdrop="static"  >
          <Modal.Header className="bg-iot  text-dark" closeButton>
              <Modal.Title> Cambio de contraseña</Modal.Title>
          </Modal.Header> 
          <Modal.Body>
                 <Formik
                     enableReinitialize= {true}
                     initialValues={inic}
                     validationSchema={validationSchema}
                     onSubmit={(values ) => {   

                      this.setState({grabando:true});     
                      userService.actualizarPassUsuario(values).then(
                        data => { 
                          this.setState({grabando:false});         
                          alertService.msg('Password actualizado exitosamente.');                         
                          this.props.handleClose();
                        },
                        error=>{
                          this.setState({grabando:false});      
                          alertService.error(error);
                        }
                      );   
          
                     }}>
                             {({ errors, touched,values }) => (
                             <Form>
                               <Row>
                                  <Col sm={12}>                                   
                                 
                                        <label htmlFor="password">Contraseña </label>
                                        <ErrorMessage name={`password`} />
                                        <div className="mb-2">
                                            <CampoPassword
                                                mostrar={mostrar}
                                                onToggle={()=>this.setState({mostrar:!this.state.mostrar})}
                                            >
                                                <Field name="password" type={mostrar?"text":"password"}/>
                                            </CampoPassword>
                                        </div>
                                       
                                  </Col>
                                  <Col sm={12}>  
                                      <label htmlFor="confpassword">Confirmar Contraseña </label>
                                          <ErrorMessage name={`confpassword`} />
                                        <div className="mb-2">
                                            <CampoPassword
                                                mostrar={mostrar}
                                                onToggle={()=>this.setState({mostrar:!this.state.mostrar})}
                                            >
                                                <Field name="confpassword" type={mostrar?"text":"password"}/>
                                            </CampoPassword>
                                        </div>
                                  </Col>    
                                 </Row>                               
                                 <div className="justify-content-center mt-5 p-3 row border-top bg-light">                                    
                                    <button className="button" type="submit" data-type='primary'  disabled={this.state.grabando}>
                                        <i className="icon-floppy"></i> Grabar <LoadingBoton grabando={this.state.grabando}/>
                                    </button>
                                  </div> 
                             </Form>
                             )}
                 </Formik>
                 </Modal.Body>                     
          </Modal> 
         )};
}

function mapState(state) {
    return {  };
}

const actionCreators = {
}

const connectedFormCambiarPassword = connect(mapState, actionCreators)(FormCambiarPassword);
export { connectedFormCambiarPassword as FormCambiarPassword };